import { Cloud, Server, Globe, HardDrive } from 'lucide-react'
import type { CloudProvider } from '@/core/infra_types'

interface CloudProviderIconProps {
  provider: CloudProvider
  className?: string
  size?: number
}

const providerConfig: Record<CloudProvider, { icon: typeof Cloud; label: string; color: string }> = {
  gcp: { icon: Cloud, label: 'Google Cloud', color: 'text-blue-500' },
  azure: { icon: Globe, label: 'Microsoft Azure', color: 'text-sky-600' },
  aws: { icon: Server, label: 'Amazon Web Services', color: 'text-orange-500' },
  upcloud: { icon: HardDrive, label: 'UpCloud', color: 'text-violet-600' },
  none: { icon: Server, label: 'On-Premise', color: 'text-slate-600' },
}

export function CloudProviderIcon({ provider, className, size = 20 }: CloudProviderIconProps) {
  const config = providerConfig[provider]

  if (!config) {
    return <Cloud size={size} className={className} />
  }

  const Icon = config.icon

  return (
    <span title={config.label}>
      <Icon size={size} className={`${config.color} ${className ?? ''}`} />
    </span>
  )
}
